import { useEffect, useRef } from 'react';

import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { Products } from '@/shared/types/Billing';

export const usePricingExperimentExposure = (
  products?: Products,
  ready = true,
  sendExposure = MixpanelEvents.pricingPageShown,
  openedAutomatically = false,
  pricingEntryPoint?: PricingEntryPoint,
) => {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current || !ready || !products) return;

    const experiment = products.pricing_experiment;
    const properties = {
      pricing_opened_automatically: openedAutomatically,
      ...(pricingEntryPoint ? { pricing_entry_point: pricingEntryPoint } : {}),
      // Grid C now only describes existing subscribers, not an experiment arm a visitor was exposed to.
      ...(experiment?.eligible && experiment.variant && experiment.grid !== 'C'
        ? {
            pricing_experiment_key: experiment.key,
            pricing_experiment_variant: experiment.variant,
          }
        : {}),
    };

    sendExposure(properties);
    sent.current = true;
  }, [openedAutomatically, pricingEntryPoint, products, ready, sendExposure]);
};
